import * as fetcher from '@hydra/utils/fetcher';

export async function getSearchAnalyticsWithPatterns ({ url }: { url: string }) {
  return fetcher.get('/api/gsc/searchanalytics/query-patterns', {
    searchParams: {
      url
    }
  }).json();
}
